import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnalyticsService } from './core/services/analytics.service';
import { ParticlesComponent } from './shared/particles/particles.component';
import { CookieBannerComponent } from './shared/cookie-banner/cookie-banner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ParticlesComponent, CookieBannerComponent],
  template: `
    <app-particles />
    <div class="page-content">
      <router-outlet />
    </div>
    <app-cookie-banner />
  `,
  styles: `
    .page-content {
      position: relative;
      z-index: 1;
    }
  `,
})
export class App {
  private readonly analytics = inject(AnalyticsService);

  constructor() {
    this.analytics.trackVisit();
  }
}
